import React from 'react';
import { useDispatch, useSelector, batch } from 'react-redux';
import Svg from '../shared/Svg';
import colors from '../../utils/colors';
import { addingAttendee, setSalesforceContactMap, setSelectedContacts, setAttendeesToAdd } from '../../actions/calendar';
import './AddAttendee.scss';
import { AttendeeSearchContainer } from './AttendeeSearchContainer';
import officeApi from '../../../api/officeApi';
import { changeAlertText } from '../../actions';

export const AddAttendee = () => {
  const dispatch = useDispatch();
  const attendeesToAdd = useSelector((state) => state.calendar.attendeesToAdd);
  const outlookEventAttendees = useSelector((state) => state.calendar.eventAttendees);
  const selectedContacts = useSelector((state) => state.calendar.selectedContacts);
  const salesforceContactMap = useSelector((state) => state.calendar.salesforceContactMap);
  const onBackClicked = () => {
    batch(() => {
      dispatch(addingAttendee(false));
      dispatch(setAttendeesToAdd({}));
    });
  };

  const onSaveClicked = () => {
    const attendeeList = Object.values(attendeesToAdd).map((attendee) => attendee.emailAddress);
    officeApi.addEmailsToEvent([...new Set(attendeeList)], outlookEventAttendees.required || []);
    for (const attendee of Object.values(attendeesToAdd)) {
      if (attendeeList.filter((attendeeFromList) => attendeeFromList === attendee.emailAddress).length === 1) {
        selectedContacts[attendee.emailAddress] = attendee;
      }

      if (salesforceContactMap[attendee.emailAddress]) {
        salesforceContactMap[attendee.emailAddress].push(attendee);
      } else {
        salesforceContactMap[attendee.emailAddress] = [attendee];
      }
    }
    batch(() => {
      dispatch(setSelectedContacts(selectedContacts));
      dispatch(setSalesforceContactMap(salesforceContactMap));
      dispatch(changeAlertText(`${attendeeList.length} attendee${attendeeList.length > 1 ? 's' : ''} successfully added.`));
      dispatch(addingAttendee(false));
    });
  };

  return (
    <div className={`add-attendee-container`}>
      <div className='add-attendee-back-container'>
        <button // back button out of line on left side compared to mock
          className='add-attendee-back'
          onClick={onBackClicked}
        >
          <Svg
            className='add-attendee-back-icon'
            data='/assets/back.svg'
            fill={colors.strongBlue}
            onClick={onBackClicked}
          />
        Back
        </button>
      </div>
      <div className='add-attendee-top-banner'>
        Add Attendee
      </div>
      <div className='add-attendee-status-container'>
        <div id='attendeesSelected' className='add-attendee-status-attendees-selected'>
        Attendee(s) added: {Object.keys(attendeesToAdd).length}
        </div>
        <div className='add-attendee-status-button-container'>
          <button
            className='add-attendee-status-button'
            onClick={onSaveClicked}
            disabled={Object.keys(attendeesToAdd).length === 0}>
          Add
          </button>
        </div>
      </div>
      <AttendeeSearchContainer />
    </div>
  );
};
